import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { createWorkspaceTabNavigator } from "../WorkspaceTabNavigator";
import { BottomTabNavigationProp } from "@react-navigation/bottom-tabs";
import { UserLoggedInNavigatorNavigationProp } from "@/src/TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";

export type WorkspaceRoutinesStackParamList = {
  WorkspaceRoutinesTab: object;
  WorkspaceRoutineOccasion: {
    routineId: string;
    sequenceNumber: number;
    archived: boolean;
  };
  WorkspaceRoutineTemplateDetail: {
    routineId: string;
  };
  WorkspaceRoutineTemplateStoreDetail: {
    routineId: string;
    storeId: string;
  };
  WorkspaceArchivedRoutines: object;
};

export const WorskpaceRoutinesStack =
  createNativeStackNavigator<WorkspaceRoutinesStackParamList>();

type WorkspaceRoutineTabParamList = {
  WorkspaceComplianceRoutines: object;
  WorkspaceRoutinesTemplates: {
    routineId: string;
    sequenceNumber: number;
  };
};

type WorkspaceRoutinesStackNavigationProp<
  T extends keyof WorkspaceRoutinesStackParamList,
> = CompositeNavigationProp<
  UserLoggedInNavigatorNavigationProp<"OrgHome">,
  NativeStackNavigationProp<WorkspaceRoutinesStackParamList, T>
>;

export type WorkspaceRoutinesStackScreenProps<
  T extends keyof WorkspaceRoutinesStackParamList,
> = {
  route: RouteProp<WorkspaceRoutinesStackParamList, T>;
  navigation: WorkspaceRoutinesStackNavigationProp<T>;
};

export type WorkspaceRoutinesTabScreenProps<
  T extends keyof WorkspaceRoutineTabParamList,
> = {
  route: RouteProp<WorkspaceRoutineTabParamList, T>;
  navigation: CompositeNavigationProp<
    WorkspaceRoutinesStackNavigationProp<"WorkspaceRoutinesTab">,
    BottomTabNavigationProp<WorkspaceRoutineTabParamList, T>
  >;
};

export const WorkspaceRoutinesTab =
  createWorkspaceTabNavigator<WorkspaceRoutineTabParamList>();
